import {React, Component} from 'react'

export class ErrorBoundary extends Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false,
                     error: '',
                     errorInfo: ''    
                    };
    }
  
    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      return { hasError: true, error };
    }
  
    componentDidCatch(error, errorInfo) {
      // You can also log the error to an error reporting service
     
      console.log('error', error, 'errorInfo', errorInfo);
      this.setState({ errorInfo });
    }
  
    

    render() {

        console.log('this hasError', this.state.hasError);
        const {hasError, errorInfo} = this.state;
      if (hasError) {
        // You can render any custom fallback UI
        return <div>
                <h3>
                    Something went wrong. 
                </h3>  
                <span
                    style={{ cursor: 'pointer', color: '#0077FF' }}
                    onClick={() => {
                    window.history.back();
                    }}
                >
                    Please click here to go back and refresh
                </span>{' '}
                <h1>
                    Here are the details of the Error: 
                    {errorInfo && errorInfo.componentStack.toString()} 
                </h1>
               
            </div>;
      }
  
      return this.props.children; 
    }
  }

export default ErrorBoundary;